import React from 'react';
import { Outlet, useLoaderData } from 'react-router-dom';

import Location from '@r6digital/rapidstor-types/react/entities/Location';

import { AnalyticsContextProvider } from '@/features/rapidstor/providers/AnalyticsProvider';

export default function ApiRoot() {
    const location = useLoaderData() as Location;

    return (
        <AnalyticsContextProvider location={location}>
            <Outlet />
        </AnalyticsContextProvider>
    );
}
